export default "__VITE_ASSET__BwCRZqJm__"